<template>
  <i
    style="font-size: 18px; color: rgba(255, 82, 82, 1)"
    class="iconsax"
    icon-name="x-square"
  ></i>
</template>
